import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";

const Home = ( { logged }) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  return (
    
    <Wrapper id="home--wrapper">
      <Container id="home--container">

        <Header id="home--header">
          <span className="strong">Create your own <div>PictureViewer</div> albums.</span>
          <span className="minor">New to PictureViewer? Enjoy the liberty to have all your pictures at a finger touch distance.</span>
        </Header>

        <Content className="home--Content">
          { 
            logged
          ?
            <Link to={BASE_URL+"/dashboard"}><Button>My Pictures</Button></Link> 
          :
            <Link to={BASE_URL+"/login"}><Button>Login</Button></Link>
          }
        </Content>

        <Content className="home--Content">
          <div className="image-container"><img src={BASE_URL + "/assets/img/the-liberty-homes.jpg"} alt="the-liberty-homes.jpg" title="the liberty homes" /></div>
          <div className="image-container"><img src={BASE_URL + "/assets/img/circeo-beach.jpg"} alt="the-liberty-homes.jpg" title="circeo beach" /></div>
          <div className="image-container"><img src={BASE_URL + "/assets/img/a-wonderful-woman.jpg"} alt="the-liberty-homes.jpg" title="a wonderful woman" /></div>
          <div className="image-container"><img src={BASE_URL + "/assets/img/the-bridge-and-the-arch.jpg"} alt="the-liberty-homes.jpg" title="the bridge and the arch" /></div>
        </Content>

        <Content className="home--Content">

          <Features>

            <span>The PictureViewer features</span>

            <p>
              <div className="icon-container">
                {/* <FontAwesomeIcon icon={faHome} /> */}
                <div>all in one spot</div>
              </div>
              <div>just at a finger touch distance</div>
              
            </p>
            <p>
              <div className="icon-container">
                {/* <FontAwesomeIcon icon={faHome} /> */}
                <div>organize in albums</div>
              </div>
              <div>create how many albums you need and fill them with all the images you want</div>
            </p>
            <p>
              <div className="icon-container">
                {/* <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> */}
                <div>endless searches</div>
              </div>
              <div>search by date, title and more...</div>
            </p>
            
          </Features>

        </Content>

      </Container>
    </Wrapper>
    
  )
}

export default Home;

const Wrapper = styled.div `
  width: 100%;
  /* height: 90vh; */
  min-height: 90vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
`;

const Container = styled.div `
  border: 1px solid orange;
  margin-top: 60px;
  max-width: 100%;
  padding: 30px 50px;
  background-color: rgba(0,0,0,0.4);
`;

const Header = styled.div `
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  

  span.strong {
    font-size: 1.8rem;
    font-weight: 600;
    text-align: center;

    div {
      color: orange;
    }

  }

  span.minor {
    margin-top: 30px;
    font-size: 1.2rem;
    font-weight: 400;
    text-align: center;
  }
`;

const Content = styled.div `

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  margin-top: 2.8rem;

  .image-container {
    width: 200px;
    aspect-ratio: 4/3;
    margin: 20px 10px;
    border: 1px solid orange;
    overflow: hidden;


    &:last-child {
      margin-right: 0;
    }

    img {
      /* width: 100%; */
      height: 100%
      /* object-fit: cover; */
    }
  }

`;

const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;
  width: 200px;

  cursor: pointer;
`;


const Features = styled.div `
  width: 100%;
  font-size: 1.4rem;
  font-weight: 700;

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: center; */

  p {
    margin-top: 20px;
    font-size: 1rem;
    font-weight: 100;

    display: flex;
    flex-direction: column;

    .icon-container {
      margin-right: 30px;

      display: flex;
      gap: 10px;

      div {
        font-weight: 600;
        font-size: 1.2rem;
      }
    }

    div {
      font-weight: 100;

    }
  }

`;
